import script from "./NotSubmittedText.vue?vue&type=script&setup=true&lang=ts"
export * from "./NotSubmittedText.vue?vue&type=script&setup=true&lang=ts"

import "./NotSubmittedText.vue?vue&type=style&index=0&id=8d69ae84&scoped=true&lang=scss"

import exportComponent from "D:\\a\\1\\s\\src\\ApplicantPortal.Web\\clientapp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8d69ae84"]])

export default __exports__